import { getLocalization } from 'global/global';
import { Check } from 'lucide-react';
import * as React from 'react';
import { Dropdown } from 'react-bootstrap';

interface Props {
  clientPaginate: boolean;
  selection: 'ALL' | 'VIEW' | 'NONE';
  onSelectAll: () => void;
  selectView: () => void;
}

export default function SelectAll(props: Props) {
  const { selection } = props;
  return (
    <Dropdown
      id={'table-select-all'}
      className="ms-1"
    >
      <Dropdown.Toggle size="sm">
        <Check size={14} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          id="table-dropdown-select-this-view"
          active={selection === 'VIEW'}
          onClick={props.selectView}
        >
          {getLocalization('selectThisView')}
        </Dropdown.Item>
        <Dropdown.Item
          id="table-dropdown-select-all"
          active={selection === 'ALL'}
          disabled={!props.clientPaginate}
          onClick={() => props.onSelectAll()}
        >
          {getLocalization('selectAll')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
